import {
  Environment,
  SystemOfRecord
} from "@coxauto-ui/cxm/communications/interfaces";
import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { ResponseError } from "./interfaces/api-error";
import { TextOptInStatusResponse } from "./interfaces/get-text-opt-in-status";

export async function getTextOptInStatus(
  env: Environment,
  consumerId: string,
  consumerRecordSystem: SystemOfRecord,
  consumerPhoneNumber: string
): Promise<TextOptInStatusResponse> {
  const url = `${getBaseUrl(
    env
  )}cxm/text-opt-in-status?consumerId=${consumerId}&consumerRecordSystem=${consumerRecordSystem}&consumerPhoneNumber=${consumerPhoneNumber}`;
  const header = await getHeader();

  const response = await fetchWrapper.getAsync<TextOptInStatusResponse>(
    url,
    header
  );
  if (!response?.hasError && response?.data) {
    return response.data;
  }
  const error: ResponseError = {
    isError: true,
    statusCode: response.statusCode,
    errorResult: response.error
  };
  throw error;
}
